import React from 'react';
import Resource, { ResourceInfo, ResourceProps } from '../../../components/Resource/Resource/Resource';
import { FaqDto } from '../../../interfaces/FaqDto';
import transformFaqData from './transformFaqData';

export const FaqResourceInfo: ResourceInfo = {
  name: '/App.faqResource',
  dataDst: '/App.faqData',
};

const FaqResource = <Data, Error = {}>({ ...props }: ResourceProps<Data, Error>) => (
  <Resource
    {...FaqResourceInfo}
    {...props}
    transformResponse={(faqData: FaqDto) => transformFaqData(faqData)}
  />
);
export default FaqResource;
